var _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgNewDesignRefresh = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1576_3649)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#3C3ADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0943 9.90032C20.5289 8.33491 18.3805 7.36328 15.9946 7.36328C11.2228 7.36328 7.36865 11.2282 7.36865 16C7.36865 20.7718 11.2228 24.6368 15.9946 24.6368C20.0215 24.6368 23.379 21.8838 24.3399 18.1592H22.0943C21.209 20.6747 18.8123 22.4776 15.9946 22.4776C12.4211 22.4776 9.51704 19.5735 9.51704 16C9.51704 12.4266 12.4211 9.52247 15.9946 9.52247C17.7867 9.52247 19.3845 10.2674 20.5505 11.4441L17.0742 14.9204H24.6313V7.36328L22.0943 9.90032Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1576_3649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNewDesignRefresh, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/NewDesignRefresh.e343c75c.svg";
export { ForwardRef as ReactComponent };